import React from 'react';
import { format } from 'date-fns';
import { BiBlock } from 'react-icons/bi';
import { BsArrowClockwise, BsTag } from 'react-icons/bs';
import { FaBan, FaCheckCircle, FaDownload, FaQrcode, FaRegTimesCircle, FaSpinner } from 'react-icons/fa';
import { FiClock } from 'react-icons/fi';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import { cancelBuild, retryBuild } from '../../utils/services/gitlab-service';
import QrCode from '../QrCode/QrCode';

import './BuildAndroidCard.scss';

function BuildAndroidCard({ job }) {
	function displayTime(seconds) {
		const format = (val) => `0${Math.floor(val)}`.slice(-2);
		const minutes = (seconds % 3600) / 60;
		return [minutes, seconds % 60].map(format).join(':');
	}

	formatExpirationDate;

	function formatExpirationDate(expirationDate) {
		expirationDate = new Date(expirationDate);

		var diff = getDiffDate(expirationDate);
		var isToday = diff == 0;
		var isTomorrow = diff >= 24 * 60 * 60 * 1000 * -1;

		if (isToday | isTomorrow) {
			return (
				<strong>
					Expira {isToday ? 'hoje' : 'amanhã'} às <strong> {format(expirationDate, 'HH:mm')} </strong>
				</strong>
			);
		}

		return `Expira ${format(expirationDate, 'dd/MM')} às ${format(expirationDate, 'HH:mm')}`;
	}

	function formatCreateDate(createDate) {
		createDate = new Date(createDate);

		var diff = getDiffDate(createDate);
		var isToday = diff == 0;

		var isYeasterday = diff <= 24 * 60 * 60 * 1000;

		if (isToday | isYeasterday) {
			return `Enviada ${isToday ? 'hoje' : 'ontem'} às ${format(createDate, 'HH:mm')}`;
		}

		return `Enviada ${format(createDate, 'dd/MM')} às ${format(createDate, 'HH:mm')}`;
	}

	function getDiffDate(createDate) {
		var today = new Date();
		var compDate = new Date(createDate.getFullYear(), createDate.getMonth(), createDate.getDate());
		today.setHours(0, 0, 0, 0);

		return today.getTime() - compDate.getTime();
	}

	return (
		<div className={`build-container ${job.status}`}>
			<div className="top-infos">
				<div className="icon-status">
					{job.status == 'success' && <FaCheckCircle title="Sucesso" />}
					{job.status == 'failed' && <FaRegTimesCircle title="Falha" />}
					{job.status == 'running' && (
						<FaSpinner
							className="spin"
							title="Gerando"
						/>
					)}
					{job.status == 'canceled' || (job.status == 'manual' && <FaBan title="Cancelada" />)}
				</div>
				<div className="client-infos">
					<span>
						Cliente:{' '}
						<strong>
							{(job.variables.CLIENTE || 'NÃO INFORMADO').toUpperCase()}
							{job.variables.AUTOMATIC_RELEASE == 'true' && ' - Liberação Automática'}
							{job.variables.AUTOMATIC_RELEASE == 'false' && ' - Liberação Manual'}
						</strong>
					</span>

					<span className="trigger-time">{formatCreateDate(job.created_at)}</span>
				</div>

				<div className="top-right-infos">
					<div className="job-id">
						<a
							href={job.web_url}
							target="_blank"
							title="Acessar build no GitLab">
							#<strong>{job.id}</strong>
						</a>
					</div>
					<div className="execution-time">
						<FiClock title="Tempo de execução" />
						{displayTime(job.duration)}
					</div>
				</div>
			</div>
			<div className="bottom-infos">
				<div className="ref-container">
					<span
						title="Branch / Tag"
						className="ref">
						{job.ref}
					</span>
					{job.variables.VERSAO && job.variables.VERSAO != job.ref && (
						<span
							className="version"
							title="Versão">
							{' '}
							<BsTag className="tag" /> {job.variables.VERSAO}
						</span>
					)}
				</div>
				<div className="expiration-date">
					{job.status == 'success' && job.expired && <strong>Download Expirado!</strong>}

					{!job.expired && <>{formatExpirationDate(job.artifacts_expire_at)}</>}

					{job.status != 'success' && <>-</>}
				</div>
				<div className="actions">
					{job.status != 'running' && (
						<a
							href="#"
							onClick={() => {
								retryBuild(job.id, () => {
									window.location.reload(false);
								});
							}}>
							<BsArrowClockwise
								title="Executar novamente"
								className="action"
							/>
						</a>
					)}
					{job.status == 'running' && (
						<a
							href="#"
							onClick={() => {
								cancelBuild(job.id, () => {
									window.location.reload(false);
								});
							}}
							className="cancel-action">
							<BiBlock
								title="Cancelar"
								className="action"
							/>
						</a>
					)}
					{!job.expired && job.artifacts.length > 1 && (
						<>
							<a
								href={`${job.web_url}/artifacts/download`}
								target="_blank"
								className="download-action">
								<FaDownload
									title="Download"
									className="action"
								/>
							</a>
							<a
								target="_blank"
								className="download-action">
								<FaQrcode
									onClick={() => {
										const link = `${window.RUNTIME_CONFIG.REACT_APP_URL_GET_APK_FILE}/app/qrCode/${job.id}`;

										withReactContent(Swal)
											.fire({
												title: job.variables.CLIENTE.toUpperCase(),
												confirmButtonText: 'Fechar',
												html: (
													<QrCode
														value={link}
														description={'Copiar link do .apk'}
													/>
												),
											})
											.then((response) => {});
									}}
									title="QR Code"
									className="action"
								/>
							</a>
						</>
					)}
				</div>
			</div>
		</div>
	);
}

export default BuildAndroidCard;
